export default __webpack_public_path__ + "img/Montserrat-Light_c3468d4.ttf";